import {WidgetOptions} from "./DashboardViewConfiguration";

export enum WidgetType {
    CHART = "CHART",
    CLIENTS_AND_ACCOUNTS = "CLIENTS_AND_ACCOUNTS",
    COURSE_OF_SALES = "COURSE_OF_SALES",
    MARKET_DEPTH = "MARKET_DEPTH",
    MARKET_MAP = "MARKET_MAP",
    MARKET_MOVERS = "MARKET_MOVERS",
    NEWS = "NEWS",
    ORDER_BLOTTER = "ORDER_BLOTTER",
    ORDER_DEPTH = "ORDER_DEPTH",
    QUOTE = "QUOTE",
    TIMESERIES = "TIMESERIES",
    TRADE_IDEAS  = "TRADE_IDEAS",
    WATCHLIST = "WATCHLIST",
    OPEN_TRADER_HELP = "OPEN_TRADER_HELP"
}

export function widgetTypeName(type: WidgetType): string {
    switch (type) {
        case WidgetType.CHART:
            return "Chart";
        case WidgetType.CLIENTS_AND_ACCOUNTS:
            return "Clients & Accounts";
        case WidgetType.COURSE_OF_SALES:
            return "Course of Sales";
        case WidgetType.MARKET_DEPTH:
            return "Market Depth";
        case WidgetType.MARKET_MAP:
            return "Market Map";
        case WidgetType.MARKET_MOVERS:
            return "Market Movers";
        case WidgetType.NEWS:
            return "News";
        case WidgetType.ORDER_BLOTTER:
            return "Order Blotter";
        case WidgetType.ORDER_DEPTH:
            return "Order Depth";
        case WidgetType.QUOTE:
            return "Quote";
        case WidgetType.TIMESERIES:
            return "Timeseries";
        case WidgetType.TRADE_IDEAS:
            return "Trade Ideas";
        case WidgetType.WATCHLIST:
            return "Watchlist";
        case WidgetType.OPEN_TRADER_HELP:
            return "Help";
        default:
            throw Error("Unknown Widget Type: " + type);
    }
}

export function widgetTypeIcon(type: WidgetType): string {
    switch (type) {
        case WidgetType.CHART:
            return "icon-candlestick-chart";
        case WidgetType.CLIENTS_AND_ACCOUNTS:
            return "fa fa-user";
        case WidgetType.COURSE_OF_SALES:
            return "fa fa-list-ol";
        case WidgetType.MARKET_DEPTH:
            return "fa fa-sort-amount-desc";
        case WidgetType.MARKET_MAP:
            return "fa fa-map-o";
        case WidgetType.MARKET_MOVERS:
            return "fa fa-sort-numeric-asc";
        case WidgetType.NEWS:
            return "icon-news";
        case WidgetType.ORDER_BLOTTER:
            return "fa fa-random";
        case WidgetType.ORDER_DEPTH:
            return "icon-bar-chart";
        case WidgetType.QUOTE:
            return "icon-bulb";
        case WidgetType.TIMESERIES:
            return "icon-calendar";
        case WidgetType.TRADE_IDEAS:
            return "icon-bulb";
        case WidgetType.WATCHLIST:
            return "fa fa-list";
        case WidgetType.OPEN_TRADER_HELP:
            return "fa fa-question";
        default:
            throw Error("Unknown Widget Type: " + type);
    }
}

export function widgetImplemented(type: WidgetType): boolean {
    switch (type) {
        case WidgetType.CHART:
        case WidgetType.COURSE_OF_SALES:
        case WidgetType.MARKET_MAP:
        case WidgetType.MARKET_MOVERS:
        case WidgetType.ORDER_DEPTH:
        case WidgetType.QUOTE:
        case WidgetType.TIMESERIES:
        case WidgetType.TRADE_IDEAS:
        case WidgetType.WATCHLIST:
        case WidgetType.NEWS:
        case WidgetType.OPEN_TRADER_HELP:
            return true;
        case WidgetType.CLIENTS_AND_ACCOUNTS:
        case WidgetType.MARKET_DEPTH:
        case WidgetType.ORDER_BLOTTER:
            return false;
        default:
            throw Error("Unknown Widget Type: " + type);
    }
}

export function defaultWidgetOptions(type: WidgetType): WidgetOptions {
    return {
        type,
        linked: false
    };
}
